import Resource from './Resource';

export default class ExternalFilesPost extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let config = {
			route: 'class-pages/:course_section_guid/files',
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	post() {
		return this.request('post');
	}
}
